var TEMPLATE_URL = require('./plan.selector.html');

angular.module('ikeweb.user').directive('planSelector', [

    function() {

        return {
            restrict: 'E',
            templateUrl: TEMPLATE_URL,
            replace: true,
            scope: {
                plans: '=',
                currentPlan: '=',
                selectedPlan: '=',
                onselected: '=',
                selectedTrial: '='
            },
            controller: 'planSelectorController'
        };
    }
]);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/plan/plan.selector.directive.js
// module id = 504
// module chunks = 0